import { getUserChatRooms } from "@/helpers/api/chats"

const ChatStore = {
  namespaced: true,
  state: {
		loadingChats: false,
		chats: []
  },
  mutations: {
    setLoadingChats(state, status) {
      state.loadingChats = status
    },
    setChats(state, chats) {
      state.chats = chats
    }
  },
  actions: {
    async getUserChats({ commit }, {search = null, start = 0, limit = 20} = {}) {
      commit('setLoadingChats', true)
			start = isNaN(start) ? 0 : start
      const data = {
				search,
        start,
        limit
      }
      const chat = await getUserChatRooms(data)
      if (chat.code === 200) {
        commit('setChats', chat.chat_room)
      }
      commit('setLoadingChats', false)
    }
  }
}

export default ChatStore
